import SecondaryButton from "library/Atoms/Button/SecondaryButton";
import useOrders from "pages/Dashboard/hooks/useOrders";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { checkCancellationAvailability } from "utility/helpers/orders";
import styles from "./CancelOrderBanner.styles";

const CancelOrderBanner = ({ onStartCancelling }) => {
  const { t } = useTranslation();

  const [{ selectedOrder }] = useOrders();

  if (!checkCancellationAvailability(selectedOrder?.status)) return null;
  return (
    <div className="d-flex flex-lg-column flex-row justify-content-between align-items-lg-start align-items-center gap-3 col px-0">
      <div>
        <div className="text-fs-12 text-color-secondary text-fw-semibold">
          {t("dashboard.order.cancelOrderBanner.title")}
        </div>
        <div className="text-fs-10 text-color-secondary">{t("dashboard.order.cancelOrderBanner.description")}</div>
      </div>

      <SecondaryButton
        id={`cancel-${selectedOrder.reference}-order-btn`}
        className={styles.btn}
        contentClassName="text-fs-12"
        label={t("common.buttons.cancelOrderBtn")}
        onClick={onStartCancelling}
      />
    </div>
  );
};

CancelOrderBanner.propTypes = {
  onStartCancelling: PropTypes.func.isRequired,
};

export default CancelOrderBanner;
